import { WorkflowTransitionsService } from '.'
import { ApiService } from '~/shared/api'
import type { RequestService } from '~/services/RequestService'

export default class WorkflowService extends ApiService {
  protected route: string = 'workflow'
  public transitions: WorkflowTransitionsService

  constructor(requestService: RequestService) {
    super(requestService)
    this.transitions = new WorkflowTransitionsService(requestService)
  }
}
